module.exports = __webpack_public_path__ + "images/map/map-marker-e2496c0c130245ca9594d35d62e69d12.png";